export const TENANT_ERROR_CODES = {
  NOT_FOUND: 'TENANT_NOT_FOUND',
  SUSPENDED: 'TENANT_SUSPENDED',
  MISMATCH: 'TENANT_MISMATCH',
  ROLE_NOT_ALLOWED: 'ROLE_NOT_ALLOWED',
  AUTH_UNAUTHORIZED: 'AUTH_UNAUTHORIZED',
};

const TENANT_ERROR_MESSAGES = {
  [TENANT_ERROR_CODES.NOT_FOUND]:
    'Tenant not found for this hostname. Please verify the URL.',
  [TENANT_ERROR_CODES.SUSPENDED]:
    'This tenant is suspended. Contact your platform administrator.',
  [TENANT_ERROR_CODES.MISMATCH]:
    'Your session belongs to a different tenant. Please sign in again.',
  [TENANT_ERROR_CODES.ROLE_NOT_ALLOWED]:
    'You do not have SUPER_ADMIN privileges for this action.',
  [TENANT_ERROR_CODES.AUTH_UNAUTHORIZED]:
    'Your session is no longer valid. Please sign in again.',
};

export function extractTenantError(error) {
  const serverError = error?.response?.data?.error || {};

  return {
    code: serverError.code || 'TENANT_REQUEST_FAILED',
    message: serverError.message || error?.message || 'Tenant request failed.',
    status: error?.response?.status,
  };
}

export function getTenantErrorMessage(code, fallbackMessage) {
  return (
    TENANT_ERROR_MESSAGES[code] || fallbackMessage || 'Tenant request failed.'
  );
}

export function shouldForceLogoutOnTenantError(code) {
  return [
    TENANT_ERROR_CODES.MISMATCH,
    TENANT_ERROR_CODES.AUTH_UNAUTHORIZED,
  ].includes(code);
}
